import CanalModel from './CanalModel'
import TiposDeCanaisEnum from './TiposDeCanaisEnum'

export default class CanalSmsModel extends CanalModel {
  constructor({
    id = 0,
    nome = '',
    descricao = '',
    providerAPIToken = '',
    providerIdentifier = '',
    providerId = null,
  } = {}) {
    super(id, nome, descricao, TiposDeCanaisEnum.SMS)
    this.providerAPIToken = providerAPIToken
    this.providerIdentifier = providerIdentifier
    this.providerId = providerId
  }
}
